import React from 'react';

/*
Google Definication for Structured Metadata:
https://developers.google.com/search/docs/appearance/structured-data/job-posting

Test Metadata
https://search.google.com/test/rich-results

*/

class CareerData extends React.Component {
    careerData = {
        "@context" : "https://schema.org/",
        "@type" : "JobPosting",
        "title" : "Mobile Developer - Xamarin",
        "description" : "<p>Deine Aufgaben</p><ul><li>Entwicklung von Mobile Apps auf Basis von Xamarin / .NET MAUI / Blazor</li><li>Mitwirkung bei Konzeption, Design und Programmierung</li><li>Umsetzen auf Basis vorgegebener Design-Vorlagen und Mockups (e.g. Figma)</li><li>Eigenverantwortliches Arbeiten als Teil eines agilen Teams</li></ul><p>Deine Qualifikation</p><ul><li>Abgeschlossene technische Ausbildung (HTL/FH/UNI) mit Schwerpunkt Informatik, Software Engineering oder vergleichbare Qualifikation</li><li>Interesse an Frontend Entwicklung für mobile Endgeräte</li><li>Selbständiges und lösungsorientiertes Arbeiten</li><li>Deutsch- u. Englischkenntnisse</li></ul><p>Von Vorteil sind Kenntnisse in folgenden Bereichen:</p><ul><li>Mobile Development für iOS und Android</li><li>Xamarin</li><li>.NET MAUI</li><li>Blazor</li><li>GIT</li></ul><p>Deine Benefits</p><ul><li>Fixanstellung in einem etablierten Unternehmen mit 38,5h / Woche. Kein All-In ;-)</li><li>Flexible Arbeitszeiten und flexible Home-Office Vereinbarung</li><li>Abwechslungsreiche Projekte mit flachen Hierarchien und kurzen Entscheidungswegen</li><li>Eigenverantwortliches Arbeiten in einem jungen, engagierten Team und familiären Klima</li><li>Arbeiten an Projekten mit State-of-the-art Lösungen</li><li>Gute Aufstiegschancen</li><li>Möglichkeit sich mit neuen Technologien zu befassen</li><li>Regelmäßige Teamevents, gemeinsames Mittagessen und Betriebsfeiern</li><li>Neues, modernes Office mit Blick auf die Wiener Staatsoper</li><li>Klimaanlage, Fahrradständer und Dusche im Büro.</li></ul><p>Dein Gehalt</p><p>Abhängig von Qualifizierung und Berufserfahrung wird ein marktkonformes Bruttogehalt zwischen 2.800,- und 4.200,- monatlich geboten. Darüber hinaus wird am Jahresende eine etwaige Teuerungsprämie bzw. ein am Unternehmenserfolg gemessener Bonus ausbezahlt. Solltest du dich wegen deiner langjährigen Expertise im Gehaltsschema nicht wiederfinden, laden wir dich umso mehr auf ein Gespräch mit uns ein.</p>",
        "identifier": {
          "@type": "PropertyValue",
          "name": "JobId",
          "value": "MobileDeveloper"
        },
        "datePosted" : "2023-06-02",
        "validThrough" : "2023-07-01T00:00",
        "employmentType" : "FULL_TIME",
        "hiringOrganization" : {
          "@type" : "Organization",
          "name" : "Ebner Media & Management GmbH",
          "sameAs" : "https://www.emmgt.at",
          "logo" : "https://www.emmgt.at/static/media/logo_f7a823.df1ffcca.svg"
        },
        "jobLocation": [{
          "@type": "Place",
          "address": {
          "@type": "PostalAddress",
          "streetAddress": "Opernring 7/15",
          "addressRegion": "Wien",
          "addressLocality": "Wien",
          "postalCode": "1010",
          "addressCountry": "AT"
          }
        }, {
          "@type": "Place",
            "address": {
            "@type": "PostalAddress",
            "streetAddress": "Jägerweg 4",
            "addressRegion": "Oberösterreich",
            "addressLocality": "Thalheim b. Wels",
            "postalCode": "4600",
            "addressCountry": "AT"
            }
          }],
        "baseSalary": {
          "@type": "MonetaryAmount",
          "currency": "EUR",
          "value": {
            "@type": "QuantitativeValue",
            "minValue": 2800.00,
            "maxValue": 4200.00,
            "unitText": "MONTH"
          }
        }
      }

    render() {
        return (
                <script type="application/ld+json">
                    {JSON.stringify(this.careerData)}
                </script>
        );
    }
}

export default CareerData;